module.exports = __webpack_public_path__ + "static/media/edit-permission-screenshot.2d12ca20.png";